module.exports = __webpack_public_path__ + "build/desktop/a/img/bus.84fd8fcfd0936e699b4a2c2615a64369.png";